import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const QUIPS = ["Consulting Amitabh Bachchan...", "Asking SRK's open arms...", "Rewinding the cassette...", "Searching the Filmi Universe..."];

export const ThinkingLoader = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % QUIPS.length), 900);
    return () => clearInterval(t);
  }, []);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.4 } }}
      transition={{ duration: 2, ease: "easeInOut" }}
      className="flex flex-col items-center gap-5 py-10"
      data-testid="thinking-loader-state"
    >
      <div className="vinyl relative h-24 w-24 rounded-full shadow-[0_0_40px_rgba(245,158,11,0.35)]">
        <div className="absolute inset-[34%] rounded-full bg-gradient-to-br from-amber-400 to-pink-500" />
      </div>
      <p className="font-marquee text-3xl text-amber-300 title-glow" data-testid="thinking-text">Thinking...</p>
      <p className="text-sm text-slate-400">{QUIPS[i]}</p>
    </motion.div>
  );
};
